import { render, staticRenderFns } from "./IconBelgium.vue?vue&type=template&id=58f73062&"
import script from "./IconBelgium.vue?vue&type=script&lang=ts&"
export * from "./IconBelgium.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports